import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { ChatCategory } from '@/contexts/chat/scripts/hooks/useChats/types';
import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { ChatMessageStatus } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { isMeMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/utils';
import { GroupMessageReader } from './group-message-reader';
import GroupMessageStatus from './group-message-status';
import { SingleMessageStatus } from './single-message-status';

interface MessageStatusProps {
  chat: Chat;
  message: ChatMessage;
  showReader?: boolean;
  onClick?: () => void;
}

export default function MessageStatus({
  message,
  chat,
  showReader = true,
  onClick,
}: MessageStatusProps) {
  const isMe = useMemo(() => isMeMessage(message), [message]);
  const isGroup = useMemo(() => chat.category === ChatCategory.GROUP, [chat.category]);
  const showGroupStatus = useMemo(
    () =>
      isGroup &&
      [
        ChatMessageStatus.PARTIAL_READ,
        ChatMessageStatus.UNREAD,
        ChatMessageStatus.READ,
      ].includes(message.status),
    [isGroup, message.status]
  );

  if (!isMe) {
    return null;
  }

  if (showGroupStatus) {
    if (showReader) {
      return (
        <GroupMessageReader chat={chat} message={message}>
          <GroupMessageStatus message={message}></GroupMessageStatus>
        </GroupMessageReader>
      );
    }
    return <GroupMessageStatus message={message}></GroupMessageStatus>;
  }

  return <SingleMessageStatus message={message} onClick={onClick} />;
}
